
import {
  createContext,
  useContext,
  useState,
  useCallback,
  type ReactNode,
} from "react";

import { storage } from "@/lib/storage";
import type { Service } from "@/types/service";

interface ServiceContextValue {
  selectedService: Service | null;
  selectedServiceId: string | null;
  setSelectedService: (service: Service | null, reload?: boolean) => void;
}

const ServiceContext = createContext<ServiceContextValue | null>(null);

export function ServiceProvider({ children }: { children: ReactNode }) {
  const [selectedService, setSelectedServiceState] = useState<Service | null>(
    null
  );
  const [selectedServiceId, setSelectedServiceId] = useState<string | null>(
    () => storage.getSelectedServiceId()
  );

  const setSelectedService = useCallback(
    (service: Service | null, reload = false) => {
      setSelectedServiceState(service);
      if (service) {
        setSelectedServiceId(service.id);
        storage.setSelectedServiceId(service.id);
        if (reload) {
          window.location.href = "/";
        }
      } else {
        setSelectedServiceId(null);
        storage.removeSelectedServiceId();
      }
    },
    []
  );

  return (
    <ServiceContext.Provider
      value={{ selectedService, selectedServiceId, setSelectedService }}
    >
      {children}
    </ServiceContext.Provider>
  );
}

export function useServiceStore() {
  const context = useContext(ServiceContext);
  if (!context) {
    throw new Error("useServiceStore must be used within a ServiceProvider");
  }
  return context;
}
